import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './../style/SearchContainer.module.scss';

const SearchContainer = ({ onChange, onSearch, placeholder = "Поиск по каталогу", in_footer = false }) => {
  
  const handleSubmit = (e) => {
    e.preventDefault(); // Предотвращаем стандартную отправку формы
    onSearch(); // Вызываем функцию поиска
  };

  return (
    <form 
      method="get"  
      className={in_footer ? styles.searchContainerFooter : styles.searchContainer}
      onSubmit={handleSubmit} // Добавляем обработчик submit
    >
      <input 
        name="name"
        type="text" 
        placeholder={placeholder}
        className={styles.searchInput}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button 
        type="submit" // Меняем type на "submit"
        title="Поиск"
        className={styles.searchButton}
      >
        <svg style={{ color: '#000', width: '16px', height: '16px' }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.22448 15.2824C12.5702 15.2824 15.2824 12.5702 15.2824 9.22448C15.2824 5.87875 12.5702 3.1665 9.22448 3.1665C5.87875 3.1665 3.1665 5.87875 3.1665 9.22448C3.1665 12.5702 5.87875 15.2824 9.22448 15.2824Z" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15.8333 15.8333L14.1812 14.1812" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Button>
    </form>
  );
};

export default SearchContainer;